// extracted by mini-css-extract-plugin
module.exports = {"block":"return_block__2FRB-","second":"return_second__ZwRSG","link":"return_link__1u6x-"};